export const markNotificationRead = (notificationObj) => {
  const existingmarkReadIDs = JSON.parse(localStorage.getItem('markReadID') || '[]');
  if (!existingmarkReadIDs.includes(notificationObj._id)) {
    existingmarkReadIDs.push(notificationObj._id);
    localStorage.setItem('markReadID', JSON.stringify(existingmarkReadIDs));
  }
};

export const formatNotification = (notificationStr = '') => {
  if (notificationStr.length > 65) {
    return `${notificationStr.substring(0, 62)}...`;
  }
  return notificationStr;
};

const URL_IN_BODY = /https?:\/\/[^\s]+/;
const READ_MORE_BODY_LENGTH = 75;

/**
 * The truncated list rows only justify a "Read More" button when there is more
 * to see. Attachments count: the dialog is the only place they are listed, so a
 * short announcement carrying files has no other way in.
 */
export const shouldShowReadMore = (announcement = {}) => {
  const { body = '', attachments } = announcement || {};
  if (Array.isArray(attachments) && attachments.length > 0) return true;
  return (body || '').length > READ_MORE_BODY_LENGTH || URL_IN_BODY.test(body || '');
};

export const linkifyNotification = (text) => {
  const urlRegex = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#/%?=~_|!:,.;]*[-A-Z0-9+&@#/%=~_|])/gi;
  return text.replace(urlRegex, (url) => `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`);
};

export const formatTimestamp = (dateStr) => {
  if (!dateStr) return '';
  const date = new Date(dateStr);
  return date.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  });
};
